import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvelope = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.56641 26.1768C4.56641 22.7713 4.56641 21.0685 5.16021 19.6411C5.6625 18.4336 6.46247 17.3731 7.48548 16.5584C8.6949 15.5953 10.3322 15.1275 13.6067 14.1919L25.1654 10.8894C27.0961 10.3378 28.0615 10.0619 29.0438 9.95491C29.88 9.8638 30.7235 9.8638 31.5597 9.95491C32.542 10.0619 33.5074 10.3378 35.4382 10.8894L46.9969 14.1919C50.2714 15.1275 51.9086 15.5953 53.118 16.5584C54.141 17.3731 54.941 18.4336 55.4433 19.6411C56.0371 21.0685 56.0371 22.7713 56.0371 26.1768V38.5193C56.0371 45.1328 56.0371 48.4395 54.7296 50.9565C53.6279 53.0775 51.8985 54.8069 49.7775 55.9086C47.2605 57.2161 43.9538 57.2161 37.3403 57.2161H23.2632C16.6497 57.2161 13.343 57.2161 10.8261 55.9086C8.70504 54.8069 6.97564 53.0775 5.87386 50.9565C4.56641 48.4395 4.56641 45.1328 4.56641 38.5193L4.56641 26.1768Z",
			fill: "url(#paint0_linear_198_9923)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 2.58211,
			y: -3.59367,
			width: 55.4456,
			height: 51.7694,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(2.83px)",
					clipPath: "url(#bgblur_0_198_9923_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 5.66399,
			d: "M8.74609 9.68035C8.74609 7.67269 9.33652 5.87553 10.2662 4.59264C11.1963 3.30917 12.4381 2.57031 13.7608 2.57031H46.8491C48.1718 2.57031 49.4137 3.30917 50.3437 4.59264C51.2734 5.87553 51.8638 7.67269 51.8638 9.68035V26.0871C48.047 28.999 44.8722 31.895 42.1326 34.3941C41.0564 35.3758 40.0474 36.2962 39.0929 37.1323C37.3707 38.641 35.8318 39.871 34.3825 40.7212C32.9357 41.5699 31.6098 42.0209 30.3086 42.0114C29.0357 42.0021 27.7232 41.5418 26.2801 40.6885C24.8354 39.8342 23.2928 38.6064 21.5635 37.1031C20.5992 36.2647 19.5785 35.3419 18.4895 34.3573C15.7408 31.8721 12.5569 28.9936 8.74609 26.0871V9.68035Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_198_9923)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 2.58211,
			y: -3.59367,
			width: 55.4456,
			height: 51.7694,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.68px)",
					clipPath: "url(#bgblur_1_198_9923_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 7.35296,
			x: 41.1929,
			y: 13.2368,
			width: 3.40596,
			height: 21.7883,
			rx: 1.70298,
			transform: "rotate(90 41.1929 13.2368)",
			fill: "url(#paint2_linear_198_9923)",
			fillOpacity: .9,
			stroke: "url(#paint3_linear_198_9923)",
			strokeWidth: .270524
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 2.58211,
			y: -3.59367,
			width: 55.4456,
			height: 51.7694,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.68px)",
					clipPath: "url(#bgblur_2_198_9923_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 7.35296,
			x: 41.1929,
			y: 24.2642,
			width: 3.40596,
			height: 21.7883,
			rx: 1.70298,
			transform: "rotate(90 41.1929 24.2642)",
			fill: "url(#paint4_linear_198_9923)",
			fillOpacity: .9,
			stroke: "url(#paint5_linear_198_9923)",
			strokeWidth: .270524
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3008 41.9766L55.7275 21.3174C55.934 22.522 56.0013 23.9815 56.0225 25.8145L31.46 45.7715C30.7846 46.3202 29.817 46.3202 29.1416 45.7715L4.57227 25.8096C4.59349 23.9764 4.66122 22.517 4.86816 21.3125L30.3008 41.9766Z",
			fill: "#007574"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_198_9923_clip_path",
				transform: "translate(-2.58211 3.59367)",
				children: /* @__PURE__ */ _jsx("path", { d: "M8.74609 9.68035C8.74609 7.67269 9.33652 5.87553 10.2662 4.59264C11.1963 3.30917 12.4381 2.57031 13.7608 2.57031H46.8491C48.1718 2.57031 49.4137 3.30917 50.3437 4.59264C51.2734 5.87553 51.8638 7.67269 51.8638 9.68035V26.0871C48.047 28.999 44.8722 31.895 42.1326 34.3941C41.0564 35.3758 40.0474 36.2962 39.0929 37.1323C37.3707 38.641 35.8318 39.871 34.3825 40.7212C32.9357 41.5699 31.6098 42.0209 30.3086 42.0114C29.0357 42.0021 27.7232 41.5418 26.2801 40.6885C24.8354 39.8342 23.2928 38.6064 21.5635 37.1031C20.5992 36.2647 19.5785 35.3419 18.4895 34.3573C15.7408 31.8721 12.5569 28.9936 8.74609 26.0871V9.68035Z" })
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_1_198_9923_clip_path",
				transform: "translate(-2.58211 3.59367)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 41.1929,
					y: 13.2368,
					width: 3.40596,
					height: 21.7883,
					rx: 1.70298,
					transform: "rotate(90 41.1929 13.2368)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_2_198_9923_clip_path",
				transform: "translate(-2.58211 3.59367)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 41.1929,
					y: 24.2642,
					width: 3.40596,
					height: 21.7883,
					rx: 1.70298,
					transform: "rotate(90 41.1929 24.2642)"
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_198_9923",
				x1: 56.0371,
				y1: 33.319,
				x2: 4.56641,
				y2: 33.319,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_198_9923",
				x1: 6.04021,
				y1: 4.95897,
				x2: 34.1878,
				y2: 51.8561,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_198_9923",
				x1: 41.7266,
				y1: 34.9297,
				x2: 46.2266,
				y2: 11.9297,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_198_9923",
				x1: 34.0184,
				y1: 42.6226,
				x2: 49.9116,
				y2: 8.8071,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_198_9923",
				x1: 41.7266,
				y1: 45.957,
				x2: 46.2266,
				y2: 22.957,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_198_9923",
				x1: 34.0184,
				y1: 53.6499,
				x2: 49.9116,
				y2: 19.8344,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgEnvelope);
export { ForwardRef as ReactComponent };
